<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <a :href="item | itemURL(urlWithVariationId)" class="product-link">
      <div class="thumb-title">
        {{ item | itemName }}
      </div>
      <div class="d-flex d-lg-block px-2 flex-md-wrap">
        <div class="thumb-image">
          <template v-if="Object.keys(storeSpecialExtra).length > 0" >
            <div class="storespecialextra d-none d-lg-block" :style="{'background-color':storeSpecialExtra.background}">
              <a class="d-flex" :href="storeSpecialExtra.url" :style="{ 'color': storeSpecialExtra.textColor }">
                <i class="icon-info" :style="{ 'background-color': storeSpecialExtra.background }">
                </i>
                <div class="storespecialextra-text">
                  {{ storeSpecialExtra.text }}
                </div>
              </a>
            </div>
          </template>

          <lazy-img   :image-url="itemNoPicImage"
                      class="img-fluid"
                      :alt="item | itemName"
                      :title="item | itemName">
          </lazy-img>
        </div>

        <!-- STORE SPECIALS -->
        <slot name="store-special">
          <item-store-special v-if="storeSpecial"
                              :store-special="storeSpecial"
                              :recommended-retail-price="item.prices.rrp"
                              :variation-retail-price="item.prices.default"
                              :special-offer-price="item.prices.specialOffer"
                              :decimal-count="decimalCount"
                              :item-type="item.item.itemType">
          </item-store-special>
        </slot>
        <!-- ./STORE SPECIALS -->


        <!-- ITEM DETAILS -->
        <slot name="item-details">

          <div class="thumb-content">
            <div class="product-more">

              <ul class="product-details">
                <template v-if="Object.keys(storeSpecialExtra).length > 0">
                  <li class="d-block d-lg-none" :style="{'background-color': storeSpecialExtra.background }">
                    <a class="d-flex" :href="storeSpecialExtra.url" :style="{ 'color': storeSpecialExtra.textColor }">
                      <i class="icon-info" :style="{ 'background-color': storeSpecialExtra.background }">
                      </i>
                      <span class="d-flex align-items-center text">
                        {{ storeSpecialExtra.text }}
                      </span>
                    </a>
                  </li>
                </template>
                <li v-if="item.stock.net > 0" v-tooltip data-toggle="tooltip" data-placement="top" :title="'Aktueller Lagerbestand: '+item.stock.net ">
                  <i class="icon-box"></i>
                  <span class="text">{{ item.stock.net }} <span class="d-md-none">{{ $translate("Servershop5::Template.sofortlieferbar") }}</span></span>
                </li>
                <li v-if="item.variation.availability.id==1" v-tooltip data-toggle="tooltip" data-placement="top" :title="item.variation.availability.names.name">
                  <lazy-img
                      class="product-details__img"
                      :image-url="'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable1-2.svg'"
                      :alt="'deliverable 1-2'"
                      :title="'deliverable 1-2'">
                  </lazy-img>
                  <span class="text d-md-none">{{ item.variation.availability.names.name }}</span>
                </li>
                <li v-if="item.variation.availability.id==2" v-tooltip data-toggle="tooltip" data-placement="top" :title="item.variation.availability.names.name">
                  <lazy-img
                      class="product-details__img"
                      :image-url="'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable1-3.svg'"
                      :alt="'deliverable 1-3'"
                      :title="'deliverable 1-3'">
                  </lazy-img>
                  <span class="text d-md-none">{{ item.variation.availability.names.name }}</span>
                </li>
                <li v-if="item.variation.availability.id==3" v-tooltip data-toggle="tooltip" data-placement="top" :title="item.variation.availability.names.name">
                  <lazy-img
                      class="product-details__img"
                      :image-url="'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/deliverable3-7.svg'"
                      :alt="'deliverable 3-7'"
                      :title="'deliverable 3-7'">
                  </lazy-img>
                  <span class="text d-md-none">{{ item.variation.availability.names.name }}</span>
                </li>
                <li v-if="item.variation.availability.id==4 || item.variation.availability.id==5" v-tooltip data-toggle="tooltip" data-placement="top" :title="item.variation.availability.names.name">
                  <lazy-img
                      class="product-details__img"
                      :image-url="'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/undeliverable.svg'"
                      :alt="'undeliverable'"
                      :title="'undeliverable'">
                  </lazy-img>
                  <span class="text d-md-none">{{ item.variation.availability.names.name }}</span>
                </li>
                <li v-if="item.variation.availability.id==6" v-tooltip data-toggle="tooltip" data-placement="top" :title="item.variation.availability.names.name">
                  <lazy-img
                      class="product-details__img"
                      :image-url="'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/availability/request.svg'"
                      :alt="'request'"
                      :title="'request'">
                  </lazy-img>
                  <span class="text d-md-none">{{ item.variation.availability.names.name }}</span>
                </li>
                <li v-tooltip data-toggle="tooltip" data-placement="top" :title="'Für dieses Gerät sind Upgrades verfügbar'" v-if="(item.item.free16 && item.item.free16!=0) || (item.item.free17 && item.item.free17!=0)">
                  <i class="icon-settings"></i>
                  <span class="text d-md-none">
                                        <span>{{ $translate("Servershop5::Template.upgradesAvailable") }}</span>
                                      </span>
                </li>
              </ul>

            </div>
            <!--div class="thumb-title">
                {{ item | itemName }}
            </div-->
            <div class="thumb-meta mt-2">
              <slot name="before-prices"></slot>

              <div class="prices justify-content-center" v-if="showPrice">
                <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value" class="price-view-port">
                  <del class="crossprice" v-if="item.prices.specialOffer">
                    {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                  </del>
                  <del class="crossprice" v-else>
                    {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                  </del>
                </div>

                <div class="price">
                  <template v-if="item.item.itemType === 'set'">
                    {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }} *
                  </template>
                  <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                    {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }} *
                  </template>
                  <template v-else>
                    {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }} *
                  </template>
                </div>
              </div >
            </div>

            <slot name="after-prices"></slot>

            <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
              <span>{{ item.unit.content }}</span>
              <span>&nbsp;{{ item.unit.names.name }}</span>
              <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
            </div>
          </div>
        </slot>
        <!-- ./ITEM DETAILS  -->
      </div>
    </a>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "../components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "../components/itemList/ItemStoreSpecial.vue";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial
  },
  props: {
    noImage:
        {
          type:String,
          default:'#'
        },
    decimalCount:
        {
          type: Number,
          default: 0
        },
    imageUrlAccessor:
        {
          type: String,
          default: "urlMiddle"
        },
    itemData:
        {
          type: Object
        },
    disableCarouselOnMobile:
        {
          type: Boolean
        },
    paddingClasses:
        {
          type: String,
          default: null
        },
    paddingInlineStyles:
        {
          type: String,
          default: null
        },
    forceUrlWithVariationId:
        {
          type: Boolean,
          default: false
        }
  },

  jsonDataFields: [
    "itemDataRef"
  ],

  computed:
      {
        showPrice()
        {
          let item = this.item;
          if(Object.hasOwnProperty.call(item,'tags'))
          {
            for(let i = 0; i < item.tags.length; i++)
            {
              if(item.tags[i].id === 202)
              {
                return false
              }
            }
          }
          return true
        },
        storeSpecialExtra()
        {
          let returnValue = {};
          let varProps = this.item.variationProperties;

          if( varProps && varProps.length > 0)
          {
            for(let i = 0 ; i < varProps.length ; i++)
            {
              let currentProp = varProps[i];

              if(currentProp.id == 1 )
              {
                let props = currentProp.properties

                if(props && props.length > 0)
                {
                  for(let a = 0 ; a < props.length ; a++)
                  {
                    let propCur = props[a]
                    if(propCur.id == 60)
                    {
                      return JSON.parse(propCur.values.value)

                    }
                  }
                }

              }
            }
          }

          return returnValue;
        },
        itemNoPicImage()
        {
          let images = this.item.images && this.item.images.all;
          if(!images || !images.length || images[0].urlPreview.includes('/images/gallery/Basis/'))
          {
            return this.noImageUrl;
          }
          return images[0].urlPreview
        },
        noImageUrl()
        {
          // Fallback, wenn kein no-image übergeben wurde (z.B. Zubehör & Ersatzteile auf der Artikelseite)
          if(this.noImage && this.noImage !== '#')
          {
            return this.noImage;
          }
          let lang = App.language === 'de' ? 'DE' : 'EN';
          return 'https://cdn02.plentymarkets.com/269f2q1olluv/frontend/shop/images/noImage/keinBild-Komp-' + lang + '.png';
        },
        item()
        {
          return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
          return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
          return this.item.texts;
        },

        itemPrice()
        {
          return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
          return this.$options.filters.currency(
              this.item.prices.default.price.value,
              this.item.prices.default.currency
          );
        },

        urlWithVariationId()
        {
          return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
          showNetPrices: state => state.basket.showNetPrices
        })
      }
}
</script>
